var box_cart_products = [];
function setStorage(name, value) {
  localStorage.setItem(name, JSON.stringify(value));
}
function getStorage(name) {
  const cookie = JSON.parse(localStorage.getItem(name) || "[]");;
  return cookie;
}
 
if(getStorage("elite-box-deal") != null){
    if(getStorage("elite-box-deal").length > 0) {
        box_cart_products = getStorage("elite-box-deal");
        updateCart();
        updateTiers()
        autoExpandCart(); 
    }
}

function addProduct(id,btn) {
    // Prevent double click
    if (btn.getAttribute('aria-disabled') === 'true') return;

    btn.setAttribute('aria-disabled', true);
    btn.classList.add('loading');
    btn.querySelector('.loading__spinner').classList.remove('hidden');

    setTimeout(function(){
        btn.setAttribute('aria-disabled', false);
        btn.classList.remove('loading');
        btn.querySelector('.loading__spinner').classList.add('hidden');
    },400)

    const product = box_products.find(p => p.id === id);
    const variantSelect = document.getElementById(`variants-${product.id}`);
    const selectedVariant = parseInt(variantSelect ? variantSelect.value : product.variants[0].id);
    const variants = product.variants;
    const variant = variants.find(v => v.id === selectedVariant);
    const quantitySelector = document.getElementById(`box-quantity-${product.id}`);
    const quantity = parseInt(quantitySelector.value || 1);
    const cart_item = {id:variant.id,quantity:quantity,product_id:product.id,name:product.name,variant:variant, variant_options:product.variant_options, featured_image:product.featured_image};
    const check_cart_index = box_cart_products.findIndex(line_item => line_item.id === variant.id);
    if(check_cart_index > -1){
        const updated_quantity = box_cart_products[check_cart_index].quantity + quantity;
        box_cart_products[check_cart_index].quantity = updated_quantity;
    }else{
        box_cart_products.push(cart_item);
    }
    updateCart();
    updateTiers()
    autoExpandCart();
}

function getCurrentTier() {
    const totalItems = box_cart_products.reduce((sum, p) => sum + (p.quantity), 0);
    if (totalItems >= 5) return { products: 5, discount: 20 };
    if (totalItems >= 4) return { products: 4, discount: 15 };
    if (totalItems >= 3) return { products: 3, discount: 10 };
    if (totalItems >= 2) return { products: 2, discount: 5 };
    return null;
}

function updateCart() {
    setStorage("elite-box-deal", box_cart_products);
    const cartContent = document.getElementById('cartContent');
    const cartBadge = document.getElementById('cartBadge');
    
    const totalItems = box_cart_products.reduce((sum, cart_line) => sum + cart_line.quantity, 0);
    
    if (box_cart_products.length === 0) {
        document.querySelectorAll('.is-in-box').forEach(card => {
            card.classList.remove('is-in-box');
        });
        cartContent.innerHTML = `
            <div class="cart-empty">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin: 0 auto 16px; opacity: 0.3;">
                    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <path d="M16 10a4 4 0 0 1-8 0"></path>
                </svg>
                <p style="font-weight: 500;">Your box is empty</p>
                <p style="font-size: 14px; margin-top: 8px;">Start selecting products</p>
            </div>
        `;
        cartBadge.style.display = 'none';
        return;
    }

    cartBadge.style.display = 'flex';
    cartBadge.textContent = totalItems;

    const subtotal = box_cart_products.reduce((sum, p) => sum + (p.variant.price * (p.quantity)), 0);
    const tier = getCurrentTier();
    const discount = tier ? (subtotal * tier.discount) / 100 : 0;
    const total = subtotal - discount;
    document.querySelectorAll('.is-in-box').forEach(card => {
        card.classList.remove('is-in-box');
    });
    const r_box_cart_products = [...box_cart_products].reverse();
    const cartItems = r_box_cart_products.map(cart_line => {

        const product = box_products.find(p => p.id === cart_line.product_id);
        if(!product) removeProduct(cart_line.id);

        const qty = cart_line.quantity;
        const itemTotal = cart_line.variant.price * qty;
        // Shopify.formatMoney(500,Shopify.money_format)
        const variant = cart_line.variant;
        document.querySelector(`.product-card[data-id="${cart_line.product_id}"]`).classList.add('is-in-box');

        let v_img;
        if (variant.featured_image) {
            v_img = variant.featured_image.src + "&width=400";
        } else {
            v_img = cart_line.featured_image + "&width=400";
        }
        let variant_option = cart_line.variant.options.map((opt, i) => `<span>${cart_line.variant_options[i]}: ${opt}</span>`).join("");
        return `
        <div class="cart-item">
            <div class="cart-item-img">
                <img src="${v_img}">
            </div>
            <div class="cart-item-info">
                <div class="cart-item-name">${cart_line.name}</div>
                <div class="cart-item-variant">
                ${variant_option}
                </div>
                <div class="cart-item-price">
                    ${Shopify.formatMoney(cart_line.variant.price, Shopify.money_format)} × ${qty} = ${Shopify.formatMoney(itemTotal, Shopify.money_format)}
                </div>
                <div class="cart-actions">
                    <div class="cart-quantity">
                        <button class="cart-quantity-btn" onclick="updateCartQuantity(${cart_line.id}, -1)">−</button>
                        <span class="cart-quantity-display">${qty}</span>
                        <button class="cart-quantity-btn" onclick="updateCartQuantity(${cart_line.id}, 1)">+</button>
                    </div>
                    <button class="cart-item-remove" onclick="removeProduct(${cart_line.id})">✕</button>
                </div>

            </div>
        </div>
    `}).join('');

    let nextTierMessage = '';
        if (!tier && totalItems > 0) {
            if (totalItems < 2) {
                nextTierMessage = `<div class="cart-message"><strong>Add ${2 - totalItems} more item${2 - totalItems === 1 ? '' : 's'}</strong> to get <strong>5% off!</strong></div>`;
            } else if (totalItems === 2) {
                nextTierMessage = `<div class="cart-message"><strong>Add 1 more item</strong> to get <strong>10% off!</strong></div>`;
            }
        } else if (tier) {
            if (tier.products === 2) {
                nextTierMessage = `<div class="cart-message"><strong>Add ${3 - totalItems} more item${3 - totalItems === 1 ? '' : 's'}</strong> to get <strong>10% off!</strong></div>`;
            } else if (tier.products === 3) {
                nextTierMessage = `<div class="cart-message"><strong>Add ${4 - totalItems} more item${4 - totalItems === 1 ? '' : 's'}</strong> to get <strong>15% off!</strong></div>`;
            } else if (tier.products === 4) {
                nextTierMessage = `<div class="cart-message"><strong>Add ${5 - totalItems} more item${5 - totalItems === 1 ? '' : 's'}</strong> to get <strong>20% off!</strong></div>`;
            }
        }

    cartContent.innerHTML = `
        <div class="cart-items">${cartItems}</div>
        <div class="cart-totals">
            <div class="cart-row">
                <span>Subtotal</span>
                <span style="font-weight: 600;">${Shopify.formatMoney(subtotal, Shopify.money_format)}</span>
            </div>
            ${tier ? `
                <div class="cart-row discount">
                    <span>Discount (${tier.discount}%)</span>
                    <span>-${Shopify.formatMoney(discount, Shopify.money_format)}</span>
                </div>
            ` : ''}
            <div class="cart-row total">
                <span>Total</span>
                <span>${Shopify.formatMoney(total, Shopify.money_format)}</span>
            </div>
        </div>
        ${nextTierMessage}
        <box-add-to-cart>
        <button class="cart-checkout button">
            <span>Add to Cart</span>
            <div class="loading__spinner hidden">
                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        </button>
        </box-add-to-cart>
    `;
};

document.querySelectorAll('.variant-select').forEach(selectEl => {
  selectEl.addEventListener('change', function() {

    const id = parseInt(this.dataset.pid);
    const product = box_products.find(p => p.id === id);

    const variantSelect = document.getElementById(`variants-${product.id}`);
    const selectedVariant = parseInt(variantSelect ? variantSelect.value : product.variants[0].id);

    const variant = product.variants.find(v => v.id === selectedVariant);

    let v_img;
    if (variant.featured_image) {
      v_img = variant.featured_image.src + "&width=400";
    } else {
      v_img = product.featured_image + "&width=400";
    }

    document.querySelector(`.product-card[data-id="${id}"] img`).setAttribute("srcset", v_img);
    let priceElement;

    if (variant.price < variant.compare_at_price) {
      priceElement = `<span class="p-regular-price color-red">${Shopify.formatMoney(variant.price, Shopify.money_format)}</span>
        <span class="p-was-price">${Shopify.formatMoney(variant.compare_at_price, Shopify.money_format)}</span>`;
    } else {
      priceElement = `<span class="p-regular-price">${Shopify.formatMoney(variant.price, Shopify.money_format)}</span>`;
    }

    document.querySelector(`.product-card[data-id="${id}"] .product-price`).innerHTML = priceElement;
  });
});

 // Mobile cart toggle
function toggleCart() {
    const cart = document.getElementById('cartSidebar');
    cart.classList.toggle('expanded');
}

function toggleCartMobile() {
    if (window.innerWidth <= 1024) {
        toggleCart();
    }
}

// Auto-expand cart on mobile when items are added
function autoExpandCart() {
    if (window.innerWidth <= 1024 && box_cart_products.length > 0) {
        setTimeout(function(){
            const cart = document.getElementById('cartSidebar');
            cart.classList.add('expanded');
        },100);
    }
}
// Close cart when clicking outside on mobile
document.addEventListener('click', function(event) {
    if (window.innerWidth <= 1024) {
        const cart = document.getElementById('cartSidebar');
        const isClickInsideCart = cart.contains(event.target);
        const isClickOnProduct = event.target.closest('.product-card') || event.target.closest('.product-button');
        const isClickOnCartButton = event.target.closest('.cart-quantity-btn') || event.target.closest('.cart-item-remove') || event.target.closest('.cart-checkout');
        //  && !isClickOnProduct
        if (!isClickInsideCart && !isClickOnCartButton && cart.classList.contains('expanded')) {
            cart.classList.remove('expanded');
        }
    }
});

function updateTiers() {
    const tier = getCurrentTier();
    document.querySelectorAll('.tier-card').forEach(card => {
        card.classList.remove('active');
        if (tier && parseInt(card.dataset.products) === tier.products) {
            card.classList.add('active');
        }
    });
}

function updateCartQuantity(id, change) {
    const line_item = box_cart_products.find(line_item => line_item.id === id);
    const line_item_index = box_cart_products.findIndex(line_item => line_item.id === id);
    if (!line_item) return;

    const cartItems = document.querySelector('.build-your-own-box .cart-items');
    const scrollPos = cartItems ? cartItems.scrollTop : 0;
    const cart_updated_quantity = Math.max(1, box_cart_products[line_item_index].quantity + change);

    box_cart_products[line_item_index].quantity = cart_updated_quantity;
    
    updateCart();
    updateTiers()
    // autoExpandCart();

    // Restore scroll position after DOM update
    setTimeout(() => {
        const cartItemsUpdated = document.querySelector('.build-your-own-box .cart-items');
        if (cartItemsUpdated) {
            cartItemsUpdated.scrollTop = scrollPos;
        }
    }, 0);
}

function filterByCategory(category,el) {
  category = category.toLowerCase();

  document.querySelectorAll('.category-btn').forEach(cat => { cat.classList.remove('active'); });
  el.classList.add('active');
  if (category === "all") {
    document.querySelectorAll('.product-card').forEach(card => { card.style.display = ''; });
    return;
  }

  const matched = box_products.filter(p => {
    if (!p.collections) return false;
    const cols = p.collections.toLowerCase().split(',').map(c => c.trim());
    return cols.includes(category);
  });

  const idsToShow = matched.map(p => p.id);
  document.querySelectorAll('.product-card').forEach(card => { card.style.display = 'none'; });

  idsToShow.forEach(id => {
    const card = document.querySelector(`.product-card[data-id="${id}"]`);
    if (card) card.style.display = '';
  });
}

function removeProduct(id) {
    // Save scroll position
    const cartItems = document.querySelector('.build-your-own-box .cart-items');
    const scrollPos = cartItems ? cartItems.scrollTop : 0;

    const line_item_index = box_cart_products.findIndex(line_item => line_item.id === id);
    box_cart_products.splice(line_item_index, 1);
    updateCart();
    updateTiers()
    autoExpandCart();

    // Restore scroll position after DOM update
    setTimeout(() => {
        const cartItemsUpdated = document.querySelector('.build-your-own-box .cart-items');
        if (cartItemsUpdated) {
            cartItemsUpdated.scrollTop = scrollPos;
        }
    }, 0);
}

class BoxAddToCart extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector('button');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        document.querySelectorAll('.product-button').forEach(btn => {
            btn.classList.add('disabled');
            btn.disabled = true;
        });
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var formData = { 'items': [] };
        console.log("this.cart",this.cart);
        formData.sections_url = window.location.pathname;
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        for(var i=0; i<box_cart_products.length; i++){
            var $cart_item = box_cart_products[i];
            formData.items.push({ 'id': $cart_item.variant.id,'quantity': $cart_item.quantity, properties:{'_build_your_own_box':"true"} })
        }
        config.body = JSON.stringify(formData);
        config.headers['Content-Type'] = "application/json";
        var cart_add_url = `${routes.cart_add_url}.js`;

        fetch(cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            box_cart_products = [];
            updateCart();
            updateTiers()
            autoExpandCart();
            const cart = document.getElementById('cartSidebar');
            cart.classList.remove('expanded');

            document.querySelectorAll('.product-button').forEach(btn => {
                btn.classList.remove('disabled');
                btn.disabled = false;
            });
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
    });
  }
}
customElements.define('box-add-to-cart', BoxAddToCart);